import { config } from 'config';
import { Building2, Cloud, Folder, StickyNote, Users } from 'lucide-react';
import { nanoid } from '~/utils/nanoid';

/*************************************************************************************************
 * Nav
 ************************************************************************************************/

export const marketingNavConfig = [
  { id: 'product', url: '/about', hash: 'product' },
  // { id: 'pricing', url: '/about', hash: 'pricing' },
  { id: 'docs', url: `${config.backendUrl}/docs`, hash: '' },
];

/*************************************************************************************************
 * Footer
 ************************************************************************************************/

export const socials = [{ title: 'BlueSky', href: config.company.blueskyUrl, icon: Cloud }];

export const footerSections = [
  {
    title: 'common:product',
    links: [
      { title: 'common:about', href: '/about' },
      { title: 'common:sign_up', href: '/auth/authenticate' },
    ],
  },
  {
    title: 'common:documentation',
    hideOnMobile: true,
    links: [
      { title: 'common:api_docs', href: `${config.backendUrl}/docs` },
      { title: 'common:architecture', href: 'https://github.com/cellajs/cella/blob/main/info/ARCHITECTURE.md' },
      { title: 'common:roadmap', href: 'https://github.com/cellajs/cella/blob/main/info/ROADMAP.md' },
    ],
  },
  {
    title: 'common:connect',
    links: [{ title: 'common:contact_us', href: '/contact' }, ...socials],
  },
];

/*************************************************************************************************
 * Legal
 ************************************************************************************************/

export const legalLinks = [{ title: 'common:legal', href: '/legal' }];

/*************************************************************************************************
 * About - Features
 ************************************************************************************************/

export const features = [];

/*************************************************************************************************
 * About - Pricing plan
 ************************************************************************************************/

interface PricingPlan {
  id: string;
  action: 'sign_in' | 'contact_us' | 'waitlist_request';
  priceId: string | null;
  featureCount: number;
  borderColor: string;
  popular?: boolean;
  discount?: string;
}

export const pricingPlans: PricingPlan[] = [
  { id: 'free', action: 'waitlist_request', priceId: null, featureCount: 4, borderColor: '', discount: 'Free' },
  { id: 'pro', action: 'contact_us', priceId: null, featureCount: 6, borderColor: 'ring-4 ring-primary/5', popular: true },
];

/*************************************************************************************************
 * About - FAQ
 ************************************************************************************************/

export const faqsData = [
  { id: 'roadmap' },
  { id: 'open-source-software', link: '/contact' },
  { id: 'linear-comparison' },
  { id: 'pivotal-comparison', link: 'https://news.ycombinator.com/item?id=41591622' },
  { id: 'raak-integration' },
  { id: 'pivotal-migrations', link: '/contact' },
];

/*************************************************************************************************
 * About - Counters
 ************************************************************************************************/

export const counts = [
  { id: 'user', title: 'common:users', icon: Users },
  { id: 'organization', title: 'common:organizations', icon: Building2 },
  { id: 'project', title: 'app:projects', icon: Folder },
  { id: 'task', title: 'app:tasks', icon: StickyNote },
] as const;

/*************************************************************************************************
 * About - Why
 ************************************************************************************************/

export const whyItems = [{ id: 'simple' }, { id: 'automation' }, { id: 'instant' }];

// Slides for light and dark themes
export const whyLightSlides = [
  { id: nanoid(), url: '/static/screenshots/board.png' },
  { id: nanoid(), url: '/static/screenshots/table.png' },
  { id: nanoid(), url: '/static/screenshots/task.png' },
];

export const whyDarkSlides = [
  { id: nanoid(), url: '/static/screenshots/board-dark.png' },
  { id: nanoid(), url: '/static/screenshots/table-dark.png' },
  { id: nanoid(), url: '/static/screenshots/task-dark.png' },
];
